// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"364":"569e3909e98490bd","440":"e08c668dba1ff4c9","581":"d7259ea191ed64cb","681":"5aafe30ae65e0a7a","717":"ff24e90321a7ad26"}[chunkId] + ".js";
};